<mat-toolbar class="shadow primary-bg-color">
  <div style="margin-left:3%;">
    <a href="https://liverpool.com.mx/tienda/home"><img id="logo"/></a>
  </div>

  <span class="spacer"></span>
  <div class="d-none d-sm-none d-md-block" style="margin-right:3%;">  
    <span class="spacer"></span>
    <div class="popover__wrapper d-none d-sm-none d-md-block" >
      <a href="#" style="font-size:14px;font-weight:normal;cursor:pointer;color:white;text-decoration: none;">
        {{ 'LOGO_TOOLBAR.LABEL1' | translate }} {{this.storageService.getData('userName')}}
      </a>
      <div class="popover__content">
        <span class="text-muted" style="font-size:14px;font-weight:normal;cursor:pointer;" (click)="logOut()"> {{ 'LOGO_TOOLBAR.LABEL2' | translate }} </span>
      </div>
    </div>
  </div>
<!-- <div style="margin-right:3%">
  <button mat-icon-button class="example-icon favorite-icon" aria-label="Example icon-button with heart icon">
    <div style="font-size: 10px; position: absolute; top: -15px; width: 100%;"> Ayuda</div>
    <i class="fa-solid fa-circle-question"></i>
  </button>
</div> -->
</mat-toolbar>